import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (!payload.exp) return false;
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

export default function AuthWatcher() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem("token");
      if (token && isTokenExpired(token)) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    };

    checkToken();
    const interval = setInterval(checkToken, 60 * 1000);
    return () => clearInterval(interval);
  }, [navigate]);

  return null;
}